<div class="col-md-12 loading-container" *ngIf="loading">
  <div class="loading">
    <div class="spinner-border" role="status">
      <span class="sr-only"></span>
    </div>
  </div>
</div>
<div class="col-md-12" *ngIf="!loading">
  <div class="success-wrapper">
    <div class="header-section">
      <div class="title">Apply Your Balance</div>
      <div class="yellow-bar"></div>   
    </div>
    <div class="cash-rewards-section mobile">
      <div class="cash">
        <div class="type">CASH</div>
        <div class="max-amount">{{ walletDetails?.cash?.totalCashBalance | currency: 'USD' }}</div>
      </div>
      <div class="gray-divider" *ngIf="!isBilliant"></div>
      <div class="rewards" *ngIf="!isBilliant">
        <div class="type">REWARDS</div>
        <div class="max-amount">{{ walletDetails?.rewards?.totalRewardBalance | number }}<span
            class="supination">PTS</span>
        </div>
      </div>
    </div>
    <div class="success-box" *ngIf="isSuccess && !isPPI">
      <div><img src="../../../../../assets/icons/ppi_like_button.svg" class="img-format"></div>
      <div class="title">Thank you for your payment</div>
      <!-- If they earned at least 1 point when paying the invoice flow -->
      <div *ngIf="totalPointsEarned > 0 && !isBilliant">Congratulations! You just earned <span class="green">{{ totalPointsEarned | number: '1.0-0' }} pts</span> for Invoice <span class="bold">#{{ paidInvoiceDetails?.invoiceNumber }}</span></div>
      <div class="points-earned" *ngIf="totalPointsEarned > 0">
        <ul class="no-bullet-points">
          <li *ngIf="cashPointsEarned > 0"><div>My Cash Payment: <span class="green">+{{ cashPointsEarned | number: '1.0-0' }} pts</span></div></li>
          <li *ngIf="achPointsEarned > 0"><div>ACH Payment: <span class="green">+{{ achPointsEarned | number: '1.0-0' }} pts</span></div></li>
          <li *ngIf="earlyPointsEarned > 0"><div>Early Bill Payment: <span class="green">+{{ earlyPointsEarned | number: '1.0-0' }} pts</span></div></li>
        </ul>
      </div>
      <!-- If they earned no points when paying the invoice flow -->
      <div *ngIf="totalPointsEarned == 0 || !totalPointsEarned">Your payment has been made for the following invoice:</div>
      <div *ngIf="totalPointsEarned == 0 || !totalPointsEarned" class="invoice-number"><span class="bold">#{{ paidInvoiceDetails?.invoiceNumber }}</span></div>
      <div class="summary">All payment details can be found in your account summary. You will receive a confirmation email shortly. 
        Please note that it may take up to 24 hours for your payment to appear in your transaction history. We appreciate your patience.</div>
        <div class="buttons" *ngIf="!isBilliant"><button class="dw-primary-button icon-right" (click)="backToRewards()">Go Back to My Rewards<mat-icon>keyboard_arrow_right</mat-icon></button></div>
        <div class="buttons" *ngIf="isBilliant"><button class="dw-primary-button icon-right" (click)="backToHome()">Go Back to Homepage<mat-icon>keyboard_arrow_right</mat-icon></button></div>
    </div>
    <div class="success-box" *ngIf="!isSuccess && !isPPI">
      <div><img src="../../../../../assets/icons/ppi_failure_button.svg" class="img-format"></div>
      <div class="title">We're sorry—your payment did not go through.</div>
      <div class="summary">Please check with your bank or try again using a different payment method. Thank you!</div>
      <div class="buttons" *ngIf="!isBilliant"><button class="dw-primary-button icon-right" (click)="backToRewards()">Go Back to My Rewards<mat-icon>keyboard_arrow_right</mat-icon></button></div>
      <div class="buttons" *ngIf="isBilliant"><button class="dw-primary-button icon-right" (click)="backToHome()">Go Back to Homepage<mat-icon>keyboard_arrow_right</mat-icon></button></div>
    </div>


    <!--PPI Section-->
    <div class="success-box" *ngIf="isSuccess && isPPI">
      <div><img src="../../../../../assets/icons/ppi_like_button.svg" class="img-format"></div>
      <div class="title">Thank you for your payment</div>
      <!-- If they earned at least 1 point when paying the invoice flow -->
      <div *ngIf="totalPointsEarned > 0 && !isBilliant">Congratulations! You just earned <span class="green">{{ totalPointsEarned | number: '1.0-0' }} pts</span> for Invoice <span class="bold">#{{ paidInvoiceDetails?.invoiceNumber }}</span></div>
      <div class="points-earned" *ngIf="totalPointsEarned > 0 && !isBilliant">
        <ul class="no-bullet-points">
          <li *ngIf="cashPointsEarned > 0"><div>My Cash Payment: <span class="green">+{{ cashPointsEarned | number: '1.0-0' }} pts</span></div></li>
          <li *ngIf="achPointsEarned > 0"><div>ACH Payment: <span class="green">+{{ achPointsEarned | number: '1.0-0' }} pts</span></div></li>
          <li *ngIf="earlyPointsEarned > 0"><div>Early Bill Payment: <span class="green">+{{ earlyPointsEarned | number: '1.0-0' }} pts</span></div></li>
        </ul>
      </div>
      <!-- If they earned no points when paying the invoice flow -->
      <div *ngIf="totalPointsEarned == 0 || !totalPointsEarned">Your payment has been made for the following invoice:</div>
      <div *ngIf="totalPointsEarned == 0 || !totalPointsEarned" class="invoice-number"><span class="bold">#{{ paidInvoiceDetails?.invoiceNumber }}</span></div>
      <div class="summary">All payment details can be found in your account summary. You will receive a confirmation email shortly. 
        Please note that it may take up to 24 hours for your payment to appear in your transaction history. We appreciate your patience.</div>
        <div class="buttons" *ngIf="!isBilliant"><button class="dw-primary-button icon-right" (click)="backToRewards()">Go Back to My Rewards<mat-icon>keyboard_arrow_right</mat-icon></button></div>
        <div class="buttons" *ngIf="isBilliant"><button class="dw-primary-button icon-right" (click)="backToHome()">Go Back to Homepage<mat-icon>keyboard_arrow_right</mat-icon></button></div>
    </div>
    <div class="success-box" *ngIf="!isSuccess && isPPI">
      <div><img src="../../../../../assets/icons/ppi_failure_button.svg" class="img-format"></div>
      <div class="title">{{messageHeading}} </div>
      <div class="summary">{{messageResponse}} </div>
      <div class="buttons" *ngIf="!isBilliant"><button class="dw-primary-button icon-right" (click)="backToRewards()">Go Back to My Rewards<mat-icon>keyboard_arrow_right</mat-icon></button></div>
      <div class="buttons" *ngIf="isBilliant"><button class="dw-primary-button icon-right" (click)="backToHome()">Go Back to Homepage<mat-icon>keyboard_arrow_right</mat-icon></button></div>
    </div>
  </div>
</div>


